$(document).ready(function () {
    $(".footer-block__heading").on("click", function () {
      // Hide all other lists
      $(".list-unstyled").not($(this).next(".list-unstyled")).slideUp();
  
      // Toggle the current list
      $(this).next(".list-unstyled").slideToggle();
    });
  });
  